import { useEffect, useState } from "react";
import { StatusLED } from "@/components/infra";
import { DeckLibraryCard } from "@/components/DeckLibraryCard";
import DeckAccessModal from "@/sections/DeckAccessModal";
import { DECK_LIBRARY } from "@/lib/decks";
import { InlineChatLink } from "@/components/InlineChatLink";

export default function TheDeck() {
  const [activeDeck, setActiveDeck] = useState(null);

  useEffect(() => {
    let mounted = true;
    const onOpen = (event) => {
      const deck = DECK_LIBRARY.find((item) => item.key === event.detail?.key);
      if (deck) setActiveDeck(deck);
    };
    window.addEventListener("dcyb:open-deck", onOpen);
    document.fonts.ready.then(() => {
      if (mounted && window.location.hash === "#deck") {
        document.getElementById("deck")?.scrollIntoView({ behavior: "instant", block: "start" });
      }
    });
    return () => { mounted = false; window.removeEventListener("dcyb:open-deck", onOpen); };
  }, []);

  return (
    <section id="deck" data-testid="the-deck-section" data-chat-safe-area className="border-t hairline bg-white relative overflow-hidden scroll-mt-20">
      <div aria-hidden="true" className="absolute inset-0 pointer-events-none opacity-[0.03]" style={{ backgroundImage: "linear-gradient(0deg, #0F1117 1px, transparent 1px), linear-gradient(90deg, #0F1117 1px, transparent 1px)", backgroundSize: "44px 44px" }} />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-32">
        <div className="grid grid-cols-12 gap-y-8 gap-x-6 mb-12 md:mb-16">
          <div className="col-span-12 lg:col-span-6">
            <div data-testid="deck-library-section-label" className="font-mono-label text-[11px] text-[#0F1117] mb-6 flex items-center gap-3"><StatusLED />/ The decks</div>
            <h2 data-testid="the-deck-headline" className="font-display text-3xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-normal font-extrabold text-[#0F1117] text-balance">
              The <span className="text-chrome">Deck Library.</span>
            </h2>
          </div>
          <div className="col-span-12 lg:col-span-5 lg:col-start-8 flex lg:items-end">
            <div>
            <p data-testid="the-deck-subheading" className="text-base md:text-lg text-[#3D4049] leading-relaxed">The investor thesis, the member supply line, and the Ventures incubation model — three perspectives on the next generation of digital infrastructure.</p>
            <InlineChatLink testId="deck-library-chat-button" />
            </div>
          </div>
        </div>
        <div data-testid="deck-library" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {DECK_LIBRARY.map((deck) => <DeckLibraryCard key={deck.key} deck={deck} onSelect={setActiveDeck} />)}
        </div>
      </div>
      {activeDeck && <DeckAccessModal open deck={activeDeck} onClose={() => setActiveDeck(null)} />}
    </section>
  );
}